import { render, staticRenderFns } from "./CustomerActivityEdit.vue?vue&type=template&id=4ca867cc"
import script from "./CustomerActivityEdit.vue?vue&type=script&lang=js"
export * from "./CustomerActivityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports